import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/YatakBazaBaslik.css';
import { FaWhatsapp } from "react-icons/fa";

const YatakBazaBaslik = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (brand, category) => {
    // Türkçe karakterleri URL-friendly hale getir
    const categoryId = category
      .toLowerCase()
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
    
    navigate(`/${brand}#${categoryId}`);
  };

  return (
    <div className="yatak-baza-baslik">
      <Header />
      
      <main className="main-content">
        {/* Hero Section */}
        <section className="page-hero">
          <div className="hero-content">
            <h1>Yatak + Baza + Başlık Koleksiyonumuz</h1>
            <p>Konforlu ve huzurlu uyku için özel tasarım yatak takımları</p>
          </div>
        </section>

        {/* Categories Grid */}
        <section className="yatak-categories">
          <div className="container">
            <h2>Yatak Markalarımız</h2>
            <div className="categories-grid">
              <div className="category-card">
                <div className="category-header yatas-bg">
                  <div className="category-icon"><img width={250} src='../files/yatas-logo.png' alt="Yataş" /></div>
                  <h3>Yataş</h3>
                </div>
                <div className="category-content">
                  <p>Kaliteli uyku deneyimi için özel tasarım yatak takımları</p>
                  <div className="category-items">
                    <div className="category-item" onClick={() => handleCategoryClick('yatas-yatak', 'Yatak')}>
                      <span className="item-icon">🛏️</span>
                      <span>Yatak, Baza, Başlık Setleri</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('yatas-yatak', 'Tekstil')}>
                      <span className="item-icon">🧵</span>
                      <span>Tekstil</span>
                    </div>
                  </div>
                  <div className="category-action">
                    <Link to="/yatas-yatak" className="button">Detayları Gör →</Link>
                  </div>
                </div>
              </div>
              
              <div className="category-card">
                <div className="category-header bellona-bg">
                  <div className="category-icon"><img width={180} src='../files/bellona-logo.png' alt="Bellona" /></div>
                  <h3>Bellona</h3>
                </div>
                <div className="category-content">
                  <p>Modern tasarım ve üstün konfor bir arada</p>
                  <div className="category-items">
                    <div className="category-item" onClick={() => handleCategoryClick('bellona-yatak', 'Yatak')}>
                      <span className="item-icon">🛏️</span>
                      <span>Yatak, Baza, Başlık Ürünleri</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('bellona-yatak', 'Tekstil')}>
                      <span className="item-icon">🧵</span>
                      <span>Tekstil</span>
                    </div>
                  </div>
                  <div className="category-action">
                    <Link to="/bellona-yatak" className='button'>Detayları Gör →</Link>
                  </div>
                </div>
              </div>
              
              <div className="category-card" style={{ width: "350px", height: "615px"}}>
                <div className="category-header weltew-bg">
                  <div className="category-icon"><img width={80} src='../files/weltew-logo.png' alt="Weltew" /></div>
                  <h3>Weltew</h3>
                </div>
                <div className="category-content">
                  <p>Premium kalitede yatak takımları ve aksesuarları</p>
                  <div className="category-items">
                    <div className="category-item" onClick={() => handleCategoryClick('weltew-yatak', 'Yatak')}>
                      <span className="item-icon">🛏️</span>
                      <span>Yatak, Baza, Başlık Setleri</span>
                    </div>
                  </div>
                  <div className="category-action">
                    <Link to="/weltew-yatak" className="button">Detayları Gör →</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


        {/* Features Section */}
        <section className="yatak-features">
          <div className="container">
            <h2>Yatak Takımlarımızın Özellikleri</h2>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">🛏️</div>
                <h3>Ortopedik Tasarım</h3>
                <p>Sağlıklı uyku için ortopedik yatak tasarımları</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🌙</div>
                <h3>Konforlu Uyku</h3>
                <p>Rahat ve huzurlu uyku deneyimi sunar</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🎨</div>
                <h3>Modern Tasarım</h3>
                <p>Güncel trendlere uygun modern tasarım</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔧</div>
                <h3>Kolay Montaj</h3>
                <p>Pratik kurulum ve montaj imkanı</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🛡️</div>
                <h3>Kalite Garantisi</h3>
                <p>Tüm ürünlerimiz garanti kapsamındadır</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🚚</div>
                <h3>Ücretsiz Teslimat</h3>
                <p>Belirli bölgelerde ücretsiz teslimat</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="container">
            <div className="contact-content">
              <h2>Yatak Takımı İhtiyaçlarınız İçin Bizimle İletişime Geçin</h2>
              <p>Size en uygun yatak takımı çözümlerini sunmak için buradayız.</p>
              <div className="contact-buttons">
                <a href="tel:+905496250335" className="btn btn-primary">📞 Hemen Ara</a>
                <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <FaWhatsapp style={{ marginRight: 8, fontSize: 20, verticalAlign: 'middle' }} />
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default YatakBazaBaslik; 